import { render, staticRenderFns } from "./homeWork.vue?vue&type=template&id=6c2493cc&scoped=true&"
import script from "./homeWork.vue?vue&type=script&lang=js&"
export * from "./homeWork.vue?vue&type=script&lang=js&"
import style0 from "./homeWork.vue?vue&type=style&index=0&id=6c2493cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2493cc",
  null
  
)

export default component.exports